import React from 'react';
import _ from 'lodash';
import SearchBox from './searchBox';
import ChainSelector from '../chainSelector';
import Button from 'components/common/next/form/button';

type SidebarFiltersProps = {
  query: string;
  chainIds: string[];
  handleQueryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchBoxPlaceholderMessage: string;
  searchBoxMessage: string;
  excludedChains?: string[];
  handleChainChange: (chain: string) => void;
  children?: React.ReactNode;
  handleResetFilters?: () => void;
  resetFilterDisabled?: boolean;
};

const SidebarFilters: React.FC<SidebarFiltersProps> = ({
  query,
  handleQueryChange,
  excludedChains,
  handleChainChange,
  chainIds,
  searchBoxPlaceholderMessage,
  searchBoxMessage,
  children,
  handleResetFilters,
  resetFilterDisabled = false,
}) => {
  return (
    <>
      <SearchBox
        value={query}
        name="query"
        onChange={handleQueryChange}
        placeholder={searchBoxPlaceholderMessage}
        detail={searchBoxMessage}
      />
      {handleResetFilters && (
        <Button className="btn-rounded" disabled={resetFilterDisabled} onClick={handleResetFilters}>
          Reset filters
        </Button>
      )}
      <label>Chain</label>
      <ChainSelector chainSelection={chainIds} excludeChains={excludedChains} handleChainChange={handleChainChange} />
      {children}
    </>
  );
};

export default SidebarFilters;
